var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1156 12.8906L3.75 4.525C3.05 5.50313 2.64062 6.70312 2.64062 8C2.64062 11.3125 5.32812 14 8.64062 14C9.9375 14 11.1375 13.5906 12.1156 12.8906ZM13.5312 11.475C14.2312 10.4969 14.6406 9.29688 14.6406 8C14.6406 4.6875 11.9531 2 8.64062 2C7.34375 2 6.14375 2.40937 5.16563 3.10938L13.5312 11.475ZM0.640625 8C0.640625 5.87827 1.48348 3.84344 2.98377 2.34315C4.48406 0.842855 6.51889 0 8.64062 0C10.7624 0 12.7972 0.842855 14.2975 2.34315C15.7978 3.84344 16.6406 5.87827 16.6406 8C16.6406 10.1217 15.7978 12.1566 14.2975 13.6569C12.7972 15.1571 10.7624 16 8.64062 16C6.51889 16 4.48406 15.1571 2.98377 13.6569C1.48348 12.1566 0.640625 10.1217 0.640625 8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_632"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.640625 0H16.6406V16H0.640625V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.f86c634ef31c2a9ed0f695fa00d4d714.svg";
export { ForwardRef as ReactComponent };